RivalIQ.apps.Dashboard.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.UnknownCurationView = Marionette.ItemView.extend({
        template: '#dashboardUnknownCurationTemplate',

        behaviors: {
            Intercom: {}
        }
    });

    views.CurationErrorView = Marionette.ItemView.extend({
        template: '#dashboardCurationErrorTemplate',

        behaviors: {
            Intercom: {}
        }
    });
});
